import * as R from 'ramda';
import { common } from '@util';

const hasWidgets = R.compose(R.not, R.isNil);

export function getUpdateViewSyncedFromReportToDashboard(
    currentView,
    newLayoutOfPageGridIdOnReportMode,
    widgets = undefined,
    pageGridId = -1
) {
    if (!currentView) return;
    if (pageGridId === -1) return;
    if (!newLayoutOfPageGridIdOnReportMode) return;

    pageGridId = parseInt(pageGridId);

    let updatedView = currentView;

    // reportModeLayout update
    updatedView = R.assocPath(
        ['config', 'reportModeLayout', pageGridId, 'layout'],
        newLayoutOfPageGridIdOnReportMode,
        currentView
    );

    // reportModeLayout >> viewLayout update
    const newViewLayout = R.compose(
        common.convertLayoutFromReportModeToDashboardModeTetris,
        R.path(['config', 'reportModeLayout'])
    )(updatedView);

    updatedView = R.assocPath(
        ['config', 'viewLayout'],
        newViewLayout
    )(updatedView);

    updatedView = R.assocPath(
        ['config', 'viewLayout', 'widthUpdated'],
        true
    )(updatedView);

    // neViewLayout >> newReportModeLayout to paginate again
    // const newReportModeLayout =
    //     common.convertLayoutFromDashboardToReportMode(newViewLayout);

    // updatedView = R.assocPath(
    //     ['config', 'reportModeLayout'],
    //     newReportModeLayout
    // )(updatedView);

    if (hasWidgets(widgets)) {
        updatedView = R.assocPath(['config', 'widgets'], widgets)(updatedView);
    }

    return updatedView;
}

export function getUpdateViewSyncedFromDashboardToReportMode(
    currentView,
    newLayout,
    widgets = undefined
) {
    if (!currentView) return;
    if (!newLayout) return;

    let newViewLayout = {
        layout: newLayout,
        disabled: false,
        widthUpdated: true,
    };

    let updatedView = currentView;

    // update viewLayout
    updatedView = R.assocPath(
        ['config', 'viewLayout'],
        newViewLayout
    )(updatedView);

    // update reportMode layout whole
    const newReportModeLayout = R.compose(
        common.convertLayoutFromDashboardToReportMode,
        R.path(['config', 'viewLayout'])
    )(updatedView);

    updatedView = R.assocPath(
        ['config', 'reportModeLayout'],
        newReportModeLayout
    )(updatedView);

    // need to update widgets when []
    if (hasWidgets(widgets)) {
        updatedView = R.assocPath(['config', 'widgets'], widgets)(updatedView);
    }

    return updatedView;
}

const VIEW = 'view';
const WORKSPACE = 'workspace';
export const LOGO_TYPE = {
    VIEW: VIEW,
    WORKSPACE: WORKSPACE,
};

const isDrop = R.propEq('i', 'drop');
const isNotDrop = R.complement(isDrop);

const checkIfDropGridItemExists = (reportModeLayoutEntries) => {
    let hasDropLayout = false;
    for (const [, reportMode] of reportModeLayoutEntries) {
        const layout = R.prop('layout')(reportMode);
        if (R.any(isDrop)(layout)) {
            hasDropLayout = true;
            break;
        }
    }
    return [hasDropLayout];
};

const removeDropGridItem = (reportModeLayoutEntries) => {
    const newReportModeLayout = {};
    for (const [pageGridId, reportMode] of reportModeLayoutEntries) {
        const layout = R.prop('layout')(reportMode);
        newReportModeLayout[pageGridId] = {
            ...reportMode,
            layout: R.filter(isNotDrop)(layout),
        };
    }
    return newReportModeLayout;
};
export const removeShadowGridItemFromReportModeLayout = (currentView) => {
    const reportModeLayout = R.path(['config', 'reportModeLayout'])(
        currentView
    );
    const reportModeLayoutEntries = Object.entries(reportModeLayout);
    const [hasDropLayout] = checkIfDropGridItemExists(reportModeLayoutEntries);

    if (!hasDropLayout) {
        return;
    }

    const newReportModeLayout = removeDropGridItem(reportModeLayoutEntries);
    return newReportModeLayout;
};

export const clearReportMode = (
    currentView,
    saveView,
    selectedGridLayoutRef
) => {
    const newReportModeLayout =
        removeShadowGridItemFromReportModeLayout(currentView);

    if (!newReportModeLayout) return;
    let updatedView = currentView;
    updatedView = R.compose(
        R.assocPath(
            ['config', 'viewLayout'],
            common.convertLayoutFromReportModeToDashboardModeTetris(
                newReportModeLayout
            )
        ),
        R.assocPath(['config', 'reportModeLayout'], newReportModeLayout)
    )(updatedView);

    saveView({ view: updatedView });
    selectedGridLayoutRef.onWindowResize();
};

export const calculateSpaceForWidget = (
    currDraggingGridItemData,
    reportModeLayout
) => {
    const map = {};
    for (const [, reportMode] of Object.entries(reportModeLayout)) {
        const { pageGridId, layout } = reportMode;
        const checkResult = common.hasSpaceForAnWidget(layout, {
            h: currDraggingGridItemData.h,
            w: currDraggingGridItemData.w,
        });
        map[pageGridId] = checkResult;
    }
    return map;
};
const pageHashRegex = new RegExp('__report_page__.*__', 'ig');

export const generatePageHash = (value) => {
    return `${document.location.hash.replace(
        pageHashRegex,
        ''
    )}&__report_page__=${value}__`;
};

export const clearPageHashFromUrl = () => {
    document.location.hash = document.location.hash.replace(pageHashRegex, '');
};
